import apiService from "./BaseApi";
const BASE_NOTIFICATION_ENDPOINT = "notifications";

const NotificationsService = {
    bootProjectNotification: async (messageList) => apiService.post(`${BASE_NOTIFICATION_ENDPOINT}/twilio/send`, { messageList })
};

export default NotificationsService;
